<div class="error-page">
  <p class="message">Something went wrong!</p>
  @if (errorState) {
    <p class="sub-message"
    >{{errorState.clientMessage}}</p>
  } @else {
    <p class="sub-message">The page you're looking for either does not exist or the requested resource is currently not
    available!</p>
  }
  <button
    type="submit"
    class="btn btn-action ml-3"
  (click)="navigate()">{{!errorOnLogin ? 'Go to Home Page' : 'Go to login page'}}</button>
</div>
